/**
 * ステータスごとの並び順（優先順位）
 */
export const statusDisplayOrder = {
    /** 詳細確認中 */
    confirmDetail: 5,
    /** 見送り */
    interviewDecline: 6,
    /** 発注 */
    interviewOrder: 1,
    /** 提案 */
    offered: 2,
    /** 提案検討中 */
    proposalDoing: 4,
    /** 提案辞退 */
    proposalRefuse: 7,
    /** 提案予定 */
    proposalToDo: 3,
    /** 閲覧拒否 */
    statusDisapproved: 8,
};
